import { Injectable } from '@angular/core';
import { HttpClientService } from 'src/app/shared/services/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class MetadataService {

  constructor(private httpService: HttpClientService) { }

  // Get All Roles
  GetAllRoles = <T>() => this.httpService.get<T>(`Metadata/Roles`);

  // Gett All ContactTypes
  GetAllContactTypes = <T>() => this.httpService.get<T>(`Metadata/ContactTypes`);

  // Get All Districts
  GetAllDistricts = <T>() => this.httpService.get<T>(`Metadata/Districts`, true);

  GetAllTourTypes = <T>() => this.httpService.get<T>(`Metadata/TourType`, true);
  // Get Municipalities By District Id
  GetMunicipalitiesByDistrict = <T>(district: number) => this.httpService.get<T>(`Metadata/Municipalities/${district}`, true);

  // Get Parishes By Municipality Id
  GetParishesByMunicipality = <T>(Muncipality: number) => this.httpService.get<T>(`Metadata/Parishes/${Muncipality}`, true);
}
